import { NotificationManager } from "react-notifications";

const DEFAULT_DURATION = 3000;

export const notify = {
  success: (message, title = "Success", duration = DEFAULT_DURATION) => {
    NotificationManager.success(message, title, duration);
  },
  error: (message, title = "Error", duration = DEFAULT_DURATION) => {
    NotificationManager.error(message || "Something went wrong", title, duration);
  },
  warning: (message, title = "Warning", duration = DEFAULT_DURATION) => {
    NotificationManager.warning(message, title, duration);
  },
  info: (message, title = "Info", duration = DEFAULT_DURATION) => {
    NotificationManager.info(message, title, duration);
  },
};

export default notify;
